import { Button } from 'system/atoms';
import { candidateProfilePoolSx } from 'modules/candidate-profile/styles/candidateProfilePoolSx';
import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { useCreateTalentPoolModal } from 'modules/candidate-profile/hooks/useCreateTalentPoolModal';

export const CreateTalentPoolButton: React.FC = () => {
  const { navigateToPath } = usePathsV2();

  const { openCreateTalentPoolModal } = useCreateTalentPoolModal({
    onSuccess: (talentPoolId) => {
      navigateToPath.TALENT_POOL_DETAILS({ talentPoolId });
    }
  });

  return (
    <Button
      variant="primary"
      onClick={openCreateTalentPoolModal}
      sx={candidateProfilePoolSx.createTalentPoolButton}
    >
      Create talent list
    </Button>
  );
};
